import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient) { }

  api_url = environment.url;

  // Simple in-memory cache for session lifetime
  private permissionsCache = new Map<string, any>();

  addAccount(data: any) {
    return this.http.post(`${this.api_url}user/register`, data);
  }
  updateAccount(data: any, id: number) {
    return this.http.post(`${this.api_url}user/update/${id}`, data);
  }

  listAccount() {
    return this.http.get(`${this.api_url}user/list`)
  }
  updatePassword(id:any, data:any) {
    return this.http.post(`${this.api_url}user/changePassword/${id}`, data)
  }
  updateStatus(id:any, data:any) {
    return this.http.post(`${this.api_url}user/updateStatus/${id}`, data)
  }
  delete(id:any){
    return this.http.delete(`${this.api_url}user/delete/${id}`)
  }
  uploadFile(data:any, id:any){
    return this.http.post(`${this.api_url}user/uploadPhoto/${id}`, data)
  }
  listRoles(){
    return this.http.get(`${this.api_url}user/roles`)
  }
  permissionsByUser(id:any, opts?: { force?: boolean }): Observable<any> {
    const key = String(id);
    const useCache = !opts?.force && this.permissionsCache.has(key);
    if (useCache) {
      return of(this.permissionsCache.get(key));
    }
    return this.http.get(`${this.api_url}user/${id}/permissions`).pipe(
      tap((res:any) => {
        // Cache the entire response; adjust if only certain fields are needed
        this.permissionsCache.set(key, res);
      })
    );
  }
}
